import { buildAssetUrl } from "@/config/env";

const ASSET_SEGMENTS = ["/uploads/", "/images/"];

function startsWithAssetSegment(value: string) {
  return ASSET_SEGMENTS.some((segment) => value.startsWith(segment));
}

function startsWithRelativeAssetSegment(value: string) {
  return ASSET_SEGMENTS.some((segment) => value.startsWith(segment.slice(1)));
}

export function resolveCustomerAssetUrl(raw: string | undefined | null): string {
  if (raw == null) {
    return "";
  }

  const value = String(raw).trim().split(",")[0]?.trim() || "";
  if (!value) {
    return "";
  }

  if (value.startsWith("data:")) {
    return value;
  }

  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  if (startsWithAssetSegment(value)) {
    return buildAssetUrl(value);
  }

  if (startsWithRelativeAssetSegment(value)) {
    return buildAssetUrl(`/${value}`);
  }

  return value;
}
